/**
 * Local storage that never throws: private windows, full disks or blocked site data must not break
 * the till. What is stored here is per device (the device token, pending requests, the theme).
 */
/** The stored value, or `fallback` when there is none or it cannot be read. */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): boolean {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function remove(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // nothing to clean up
  }
}
